// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/PageLayout.scss
// module id = 1243
// module chunks = 0